import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output, ViewChild } from '@angular/core';

import { Router } from '@angular/router';
import { TableAction, TableActionEvent } from '../../models/table-action.model';
import { CdkConnectedOverlay, CdkOverlayOrigin, ConnectedPosition } from '@angular/cdk/overlay';
import { AsyncPipe, NgClass } from '@angular/common';
import { AllActionsIsHiddenPipe, ObservablePipe } from '../../pipes';
import { ClickOutsideDirective } from '../../directives';

@Component({
  selector: 'cap-row-action',
  templateUrl: './row-action.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    CdkConnectedOverlay,
    AsyncPipe,
    NgClass,
    CdkOverlayOrigin,
    AllActionsIsHiddenPipe,
    ObservablePipe,
    ClickOutsideDirective,
  ],
})
export class CapturumRowActionComponent {
  @Input() public item: any;
  @Input() public icon: string = 'fas fa-ellipsis-v';
  @Input() public actions: TableAction[] = [];
  @Input() public isOpen: boolean = false;
  @Input() public positions: ConnectedPosition[] = [
    {
      originX: 'end',
      originY: 'bottom',
      overlayX: 'end',
      overlayY: 'top',
      offsetX: 14,
      offsetY: 14,
      panelClass: 'popup--bottom',
    },
    {
      originX: 'end',
      originY: 'top',
      overlayX: 'end',
      overlayY: 'bottom',
      offsetX: 14,
      offsetY: -14,
      panelClass: 'popup--top',
    },
  ];

  @Output() public clickAction: EventEmitter<TableActionEvent> = new EventEmitter<TableActionEvent>();

  constructor(private router: Router) {}

  public executeAction(action: TableAction, item: any): void {
    this.isOpen = false;
    this.clickAction.emit({ action, item });

    if (action && action.url) {
      this.router.navigate([action.url]);
    } else if (action.callback) {
      action.callback(item);
    }
  }
}
